import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import {
  ArrowRightIcon,
  PhoneIcon,
  CreditCardIcon,
  HeartIcon,
  PlusCircleIcon
} from '@heroicons/react/24/outline';
import Topbar from '../PulseSurvey/Topbar';
import B2BPerks from './PerksAdmin';

const Offerings = () => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('userData')) || {};
  const [open, setOpen] = useState(false);

  const fetchInfo = () => {
    console.log('fetchInfo function in Perks page');
  };

  const perkCards = [
    {
      id: 1,
      title: 'Instant Support (EAP)',
      description:
        'Employee Assistance Program with 24/7 counselling and support services for your workforce.',
      icon: PhoneIcon,
      bgColor: 'bg-blue-50 dark:bg-blue-900/20',
      iconColor: 'text-blue-600 dark:text-blue-400',
      borderColor: 'border-blue-200 dark:border-blue-800',
      route: '/instant-support/b2b'
    },
    {
      id: 2,
      title: 'Salary Sacrifice',
      description:
        'Comprehensive salary sacrifice schemes with custom plans for employee benefits.',
      icon: CreditCardIcon,
      bgColor: 'bg-green-50 dark:bg-green-900/20',
      iconColor: 'text-green-600 dark:text-green-400',
      borderColor: 'border-green-200 dark:border-green-800',
      route: '/salary-sacrifice'
    },
    {
      id: 3,
      title: 'Health Scheme',
      description: 'Manage comprehensive health schemes and wellness programs for your employees.',
      icon: HeartIcon,
      bgColor: 'bg-purple-50 dark:bg-purple-900/20',
      iconColor: 'text-purple-600 dark:text-purple-400',
      borderColor: 'border-purple-200 dark:border-purple-800',
      route: '/health-scheme'
    }
  ];

  const handleCardClick = (route) => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <>
      <div className="relative lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Perks | Shoorah Admin</title>
        </Helmet>
        <Topbar title={'Perks'} infoBtn={false} setOpen={setOpen} fetchInfo={fetchInfo} />

        {/* Cards Grid */}
        <div className="mt-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {perkCards.map((perk) => (
              <div
                key={perk.id}
                onClick={() => handleCardClick(perk.route)}
                className={`
                  relative p-6 rounded-lg border-2 ${perk.borderColor} ${perk.bgColor}
                  transition-all duration-300 hover:shadow-xl
                  ${perk.route ? 'cursor-pointer hover:scale-105' : 'cursor-not-allowed opacity-75'}
                `}
              >
                {/* Icon */}
                <div
                  className={`w-12 h-12 rounded-lg ${perk.bgColor} flex items-center justify-center mb-4`}
                >
                  <perk.icon className={`w-6 h-6 ${perk.iconColor}`} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  {perk.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-4 text-sm">{perk.description}</p>

                {/* Action Button */}
                {perk.route && (
                  <div className="flex items-center text-sm font-medium text-blue-600 dark:text-blue-400">
                    <span>Manage</span>
                    <ArrowRightIcon className="w-4 h-4 ml-2" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Custom Perks Section */}
        <div className="mt-12">
          <div className="mb-6 flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Custom Perks</h2>
              <p className="text-gray-600 dark:text-gray-400 mt-2">
                Manage all custom perks created for your organization
              </p>
            </div>
            <button
              onClick={() => navigate('/offering/create')}
              className="btn-primary"
            >
              Add Perk
            </button>
          </div>

          {/* Render B2BPerks Component */}
          <B2BPerks />
        </div>
      </div>
    </>
  );
};

export default Offerings;
